module.exports = __webpack_public_path__ + "img/order-ahead.25d81b6d.png";